import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueTiposLancamentos, TTiposLancamentos } from "../../types/api/financeiro/conta-corrente-consumo-tipos-lancamentos";

export default function SelectTipoLancamentos({
    value,
    onChange,
    required = false,
    error = false,
    extraParams
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Tipo lançamento`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams }}
                        title="Selecionar tipo lançamento"
                        queryPath="/financeiro/conta-corrente-consumo/pesquisar-tipos-lancamentos"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={value || defValueTiposLancamentos}
                        onChange={(value) => {
                            onChange(value as TTiposLancamentos)
                            handleClose()
                        }}

                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TTiposLancamentos
    onChange: (arg: TTiposLancamentos | null) => void
    required?: boolean
    error?: boolean
    extraParams?: { [key: string]: any };
}